module.exports = __webpack_public_path__ + "static/media/2.e6c2d3a5.webp";